import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

// Sticky top bar of the agent center panel (specs/ai-agent-home-redesign US-1):
// group switcher pill + menu, "Made for you", right-panel toggle and minimize. Emits only; the
// parent owns navigation (selectGroup / viewAllGroups) and panel state.
@Component({
  selector: 'app-agent-top-bar',
  templateUrl: './agent-top-bar.component.html',
  styleUrls: ['./agent-top-bar.component.scss'],
})
export class AgentTopBarComponent {
  @Input() networkName = '';
  @Input() groups: any[] = [];
  @Input() currentGroupSlug = '';
  @Input() currentGroupName = '';
  @Input() showGroups = false;
  @Input() isHubOpen = true;
  // null = the whole network
  @Output() groupSelected = new EventEmitter<any | null>();
  @Output() toggleHub = new EventEmitter<void>();
  @Output() minimize = new EventEmitter<void>();

  menuOpen = false;

  constructor(private host: ElementRef<HTMLElement>) {}

  get scopeLabel(): string {
    return this.currentGroupName || this.networkName || 'All';
  }

  toggleMenu(): void {
    if (!this.showGroups) return;
    this.menuOpen = !this.menuOpen;
  }

  pick(group: any | null): void {
    this.menuOpen = false;
    this.groupSelected.emit(group);
  }

  isActive(group: any | null): boolean {
    return group ? group.group_slug === this.currentGroupSlug : !this.currentGroupSlug;
  }

  groupName(group: any): string {
    return group?.group_name || group?.name || '';
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (this.menuOpen && !this.host.nativeElement.contains(event.target as Node)) this.menuOpen = false;
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.menuOpen = false;
  }
}
